import React from 'react'
import { motion } from 'motion/react'

const AnswerContent = props => { 

  console.log(props)

  const endsound = () => {         

    props.dispatch({
      correct: false,
      incorrect: false,
      showcorrect: false,      
      selectedAnswerId: null
    })
  }

  const selectAnswer = () => {

    props.dispatch({
      selectedAnswerId: props.id,
      showcorrect: true
    })

    setTimeout(() => {

      props.dispatch({
        correct: props.esCorrecta,
        incorrect: !props.esCorrecta
      })
    
      if(props.esCorrecta) {
        
        props.state.correctsound.play({
          volume: 1,
          start: 0
        })
        .on('end', endsound)

      } else {

        props.state.incorrectsound.play({
          volume: 1,
          start: 0
        })
        .on('end', endsound)
      }
    }, 1000)
  }

  return <motion.div
    className={`
      answercontent
      ${ props.esCorrecta == props.id ? 'iscorrect' : '' }
      ${ props.state.selectedAnswerId == props.id ? 'selected' : 'notselected' }
      ${ props.state.showcorrect ? 'showcorrect' : '' }
    `}
    animate={{  
      transform: `rotateX(${ props.state.selectedAnswerId == props.id ? 180 : 0 }deg)`
    }}
    transition={{ 
      duration: 1,
      type: "spring",
      bounce: 0.7
    }}
    onClick={ selectAnswer }
  >
    <div 
      className="front"
    >
      { props.respuesta }
    </div>
    <div 
      className={`
        back
        ${ props.esCorrecta ? 'correct' : 'incorrect' }
      `}
    >
      {
        props.esCorrecta ?
        'Correcto!'
        :        
        'No es la respuesta correcta : ('
      }
    </div>
  </motion.div>
}

export default props => {

  return <motion.div
    className="answer"    
    variants={ props.item }
  >
    <AnswerContent
      { ...props }
      state={ props.state }
      dispatch={ props.dispatch }
    />
  </motion.div>
}
